import { useQuery } from "@apollo/client"

import { COACH_TOOLS_API } from "../apolloClient"
import { MEMBER_APPLY_PATH_QUERY } from "../components/queries/memberApplicationEligibility"

export const ELIGIBILITY_PATH = {
  RECIPROCITY: "RECIPROCITY",
}

/**
 * Reads which branch of Coach Tools `memberApplicationEligibility` applies.
 * `canApplyViaReciprocity` is true only for an authorized reciprocity candidate
 * who is eligible to start a Member application. Errors fail closed so the
 * dashboard is unchanged when Coach Tools is unavailable or lacks the field.
 */
export function useMemberApplyPath({ skip = false } = {}) {
  const { data, loading } = useQuery(MEMBER_APPLY_PATH_QUERY, {
    context: { api: COACH_TOOLS_API },
    fetchPolicy: "network-only",
    errorPolicy: "all",
    skip,
  })

  const eligibility = data?.memberApplicationEligibility

  return {
    loading: skip ? false : loading,
    canApplyViaReciprocity:
      eligibility?.eligible === true &&
      eligibility?.eligibilityPath === ELIGIBILITY_PATH.RECIPROCITY,
  }
}
